// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { ScoringTraitWeight, ScoringTraitWeightSchema } from 'api/gen/ScoringTraitWeight';

const requiredPart = t.interface({
  fatWeight: ScoringTraitWeightSchema,
  milkWeight: ScoringTraitWeightSchema,
  proteinWeight: ScoringTraitWeightSchema,
});

export const ProductionTraitsWeightsSchema = excess(requiredPart);

export interface ProductionTraitsWeights extends t.TypeOf<typeof ProductionTraitsWeightsSchema> {}
